export function money2(value: unknown): number {
  return Math.round((Number(value) || 0) * 100) / 100;
}

function daysInCalendarMonth(iso: string): number {
  const [year, month] = iso.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(year, month, 0, 12, 0, 0)).getUTCDate();
}

function prorateFirstInstallmentAmount(nominalMonthly: number, startDateIso: string): number {
  const day = Number(startDateIso.slice(8, 10));
  if (day <= 1) return money2(nominalMonthly);
  const dim = daysInCalendarMonth(startDateIso);
  const daysRemaining = dim - day + 1;
  return money2((nominalMonthly * daysRemaining) / dim);
}

/** Espelha o backend (`buildPlanInstallmentAmounts`) para pré-visualização na venda. */
export function buildPlanInstallmentAmounts(
  total: number,
  months: number,
  startDate: string,
  prorateFirst: boolean,
): number[] {
  const totalMoney = money2(total);
  const count = Math.max(1, Math.floor(months) || 1);
  if (count === 1) return [totalMoney];

  const nominal = money2(totalMoney / count);
  const shouldProrate = prorateFirst && Number(startDate.slice(8, 10)) > 1;

  const amounts: number[] = [];
  let accumulated = 0;

  for (let index = 0; index < count; index += 1) {
    const isFirst = index === 0;
    const isLast = index === count - 1;
    let amount: number;
    if (isLast) {
      amount = money2(totalMoney - accumulated);
    } else if (isFirst && shouldProrate) {
      amount = prorateFirstInstallmentAmount(nominal, startDate);
    } else {
      amount = nominal;
    }
    amounts.push(amount);
    accumulated = money2(accumulated + amount);
  }

  return amounts;
}

export function addMonthsIso(iso: string, months: number): string {
  const [year, month, day] = iso.slice(0, 10).split('-').map(Number);
  const target = new Date(Date.UTC(year, month - 1 + months, 1, 12, 0, 0));
  const lastDay = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0, 12, 0, 0)).getUTCDate();
  target.setUTCDate(Math.min(day, lastDay));
  return target.toISOString().slice(0, 10);
}

export function planInstallmentPreview(
  total: number,
  months: number,
  startDate: string,
  prorateFirst: boolean,
): { index: number; dueDate: string; amount: number; proportional: boolean }[] {
  const amounts = buildPlanInstallmentAmounts(total, months, startDate, prorateFirst);
  const nominal = money2(total / Math.max(1, months));
  const proratedFirst = amounts.length > 1
    && prorateFirst
    && Number(startDate.slice(8, 10)) > 1
    && amounts[0] < nominal - 0.001;

  return amounts.map((amount, index) => ({
    index: index + 1,
    dueDate: addMonthsIso(startDate, index),
    amount,
    proportional: index === 0 && proratedFirst,
  }));
}
